import React, { useEffect, useState } from "react";
import classes from "./styles.module.scss";
import { Button } from "Components/ReactstrapSlim";
import Icons from "./Icons";
import InfoIcon from "../ClaimYourProfile/InfoIcon";
import CheckAvailabilityModal from "../CheckAvailabilityModal";
import { isClaimOptionVisible } from "../ClaimYourProfile/isClaimOptionVisible";

interface NotAvailableBoxProps {
   isClaimable: LSCommon.Service.LSWebUI.Models.XPP.Claimable;
   onClaim: () => void;
   venueId: Guid;
   citySearchUrl?: string;
   checkAvailabilityButton?: HTMLButtonElement;
}

export const NotAvailableBox: React.FC<NotAvailableBoxProps> = ({ venueId, isClaimable, onClaim, citySearchUrl, checkAvailabilityButton }) => {
   const [isCheckAvailabilityOpen, setIsCheckAvailabilityOpen] = useState(false);

   useEffect(() => {
      if (checkAvailabilityButton) {
         const onClickHandler = () => setIsCheckAvailabilityOpen(true);
         checkAvailabilityButton.addEventListener("click", onClickHandler);

         return () => checkAvailabilityButton.removeEventListener("click", onClickHandler);
      }
   }, [checkAvailabilityButton]);

   return <>
      <div className={classes.container}>
         <div className={classes.body}>
            <Icons className={classes.icons} />
            <div className={classes.title}>Not available on LiquidSpace yet.</div>
            <div className={classes.description}>
               Unfortunately, this space is not on the LiquidSpace reservation network.
            </div>
            <div className={classes.text}>
               If you like, we'll notify you by email when this space joins.
            </div>
            <Button color="primary" onClick={() => setIsCheckAvailabilityOpen(true)} className={classes.buttonNotify} size="lg">Notify me</Button>
         </div>
         {
            isClaimOptionVisible(isClaimable)
               ? <div className={classes.footer}>
                  <div className={classes.footerLeft}>
                     <InfoIcon className={classes.iconInfo} onClaim={onClaim} tooltipPlacement="left" size={20} />
                     Does this space belong to you?
                  </div>
                  <Button color="link" onClick={onClaim} className={classes.buttonClaim}>Claim this profile</Button>
               </div>
               : null
         }
         <CheckAvailabilityModal venueId={venueId} isOpen={isCheckAvailabilityOpen} toggle={() => setIsCheckAvailabilityOpen(val => !val)} citySearchUrl={citySearchUrl} />
      </div>
   </>
}

export default NotAvailableBox;

